import { Link } from "../lib/router";

export function NotFound({ home }: { home: string }) {
  return (
    <div className="empty" style={{ minHeight: "100%", alignContent: "center" }}>
      <strong>There's nothing at this address.</strong>
      <p>The page may have moved, or the link is incomplete.</p>
      <Link className="btn primary" to={home}>Go to your home page</Link>
    </div>
  );
}
